// @flow
import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import ApiObjectSuggestField from './../field/ApiObjectSuggestField';
import EsbApi from './../api/EsbApi';
import {COMPONENT_CHILDREN} from './../Utils2';

/**
 * Subjekt field
 *
 * Suggest
 */
class SubjektField extends AbstractReactComponent {

    static PropTypes = {
        kodOrganizace: React.PropTypes.string.isRequired,
        kodRole: React.PropTypes.string.isRequired,
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
    };

    static defaultProps = {
        apiRequestDelay: 250,
    };

    handleFilterSuggestions = (value) => {
        const {kodOrganizace, kodRole} = this.props;
        return EsbApi.getSubjekty(value, kodOrganizace, kodRole, 20);
    };

    render() {
        const {...other} = this.props;

        return <ApiObjectSuggestField
            filterSuggestions={this.handleFilterSuggestions}
            getItemValue={(item) => item ? item.nazev : ""}
            renderSuggestion={(i, active, getItemValue) => <div className={active ? "active" : ""}>{i.nazev}</div>}
            {...other}
        />;
    }
}

export default SubjektField;
